<template>
  <span v-if="!value || value.length <= max">{{ value }}</span>
  <span v-else>
    <el-tooltip class="item" effect="dark" :content="value" placement="top">
      <span>{{ showval }}...</span>
    </el-tooltip>
  </span>
</template>

<script>
// 用于嵌入表格中防止备注出现过多文字使用
export default {
  name: "pctextmore",
  props: {
    value: {
      type: String,
      required: true,
      default: "",
    },
    max: {
      type: Number,
      default: 32,
    },
  },
  computed: {
    // 计算显示的文本内容，取前max个字符
    showval() {
      return this.value.substring(0, this.max);
    }
  },
};
</script>

<style scoped>
</style>
